import React from "react";
import NavbarForlogin from "../navbarForlogin";
import Footer from  "../Footer";
import TermsBody from "../TermsBody";


export default function TermsPage(){

return(
<div>
<NavbarForlogin />
<TermsBody/>
<Footer />
</div>

)

}